import { HttpCacheClient } from '../../core/http/http-cache-client';
import * as i0 from "@angular/core";
import * as i1 from "../../core/http/http-cache-client";
var RoleService = /** @class */ (function () {
    function RoleService(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Fetch all existing user roles.
     */
    RoleService.prototype.getRoles = function () {
        return this.httpClient.getWithCache('roles?per_page=15');
    };
    /**
     * Create a new role.
     */
    RoleService.prototype.createNew = function (data) {
        return this.httpClient.post('roles', data);
    };
    /**
     * Update existing role.
     */
    RoleService.prototype.update = function (roleId, data) {
        return this.httpClient.put('roles/' + roleId, data);
    };
    /**
     * Delete role with given id.
     */
    RoleService.prototype.delete = function (roleId) {
        return this.httpClient.delete('roles/' + roleId);
    };
    /**
     * Add users to given role.
     */
    RoleService.prototype.addUsers = function (roleId, emails) {
        return this.httpClient.post('roles/' + roleId + '/add-users', { emails: emails });
    };
    /**
     * Remove users from given role.
     */
    RoleService.prototype.removeUsers = function (roleId, userIds) {
        return this.httpClient.post('roles/' + roleId + '/remove-users', { ids: userIds });
    };
    RoleService.ngInjectableDef = i0.defineInjectable({ factory: function RoleService_Factory() { return new RoleService(i0.inject(i1.HttpCacheClient)); }, token: RoleService, providedIn: "root" });
    return RoleService;
}());
export { RoleService };
